"use client";

import { useEffect } from "@tiendanube/nube-sdk-react-runtime";
import { DrawerContent } from "../drawer-content";
import { FloatingCorners } from "../floating-corner";
import { ModalContent, type ModalContentProps } from "../modal-content";

export type RuntimeProps = ModalContentProps;

export function Runtime({ hostId }: RuntimeProps) {
	useEffect(() => {
		const theme = window.nubeSDK?.getState().store.theme;
		if (theme) {
			document.body.classList.add(`js-nubesdk-theme-${theme}`);
		}
	}, []);

	return (
		<>
			<ModalContent hostId={hostId} />
			<DrawerContent hostId={hostId} slotId="drawer_left" />
			<DrawerContent hostId={hostId} slotId="drawer_right" />
			<FloatingCorners />
		</>
	);
}
